import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import { DateFormatForDatePickerJP, DateFormatNew } from '../../../constants/date-picker-constant';
import { TrayHistoryFilterInitialState } from '../../../core/initialState/filter-initial-state';
import { ITrayHistoryFilter } from '../../../models/ITrayHIstoryFilter';
import FormikFormDatePicker from '../../../shared-components/FormikFormHandlers/FormikFormDatePicker';
import { FilterValidationSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import { formatMessage } from '../../../translations/format-message';

registerLocale('en-IN', enIN);

interface IProps {
  initialValues: any;
  submitHandler: (data: any) => void;
  filterParmas: (data: any, isfilterCleard: boolean) => void;
  isLoading: boolean;
  isFilterCleared: boolean;
}

const TrayHistoryFilterComponent = (props: IProps) => {
  const getddMMyyDateFormat = (input: string): string => {
    const date = new Date(input);

    return (
      String(date.getDate()).padStart(2, '0') +
      String(date.getMonth() + 1).padStart(2, '0') +
      String(date.getFullYear()).slice(-2)
    );
  };

  return (
    <React.Fragment>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validationSchema={FilterValidationSchema}
        validateOnBlur={false}
        onSubmit={async (values: ITrayHistoryFilter, { resetForm }) => {
          if (values.StartDate) {
            values = {
              ...values,
              StartDate: getddMMyyDateFormat(values.StartDate),
            };
          }

          if (values.EndDate) {
            values = {
              ...values,
              EndDate: getddMMyyDateFormat(values.EndDate),
            };
          }
          props.submitHandler(values);
        }}
      >
        {({ dirty, resetForm, values }) => (
          <FormikForm className="user-form pt-2 px-4">
            {props.isLoading && <FormLoader loading={props.isLoading} />}

            <Row>
              <Col md={12}>
                <div className="form-group mb-0">
                  <Label
                    className="label-style col-form-label"
                    required={false}
                    label="start_date"
                    htmlFor="StartDate"
                  />
                  <Field
                    data-testid="StartDate"
                    className="form-control"
                    name="StartDate"
                    autoComplete="off"
                    placeholder=""
                    // as={FormikFormInput}
                    // dateFormat={DateFormatForDatePickerJP}
                    dateFormat={DateFormatNew}
                    // minDate={subDays(new Date(), 0)}
                    showOutsideDays={false}
                    as={FormikFormDatePicker}
                    fixedHeight
                    maxDate={values.EndDate ? new Date(values.EndDate) : undefined}
                  />
                </div>
              </Col>
              <Col md={12}>
                <div className="form-group mb-0">
                  <Label
                    className="label-style col-form-label"
                    required={false}
                    label="end_date"
                    htmlFor="EndDate"
                  />
                  <Field
                    data-testid="EndDate"
                    className="form-control"
                    name="EndDate"
                    autoComplete="off"
                    type="text"
                    placeholder=""
                    dateFormat={DateFormatNew}
                    showOutsideDays={false}
                    as={FormikFormDatePicker}
                    fixedHeight
                    minDate={values.StartDate ? new Date(values.StartDate) : undefined}
                  />
                </div>
              </Col>

              <Col>
                <div className="d-flex justify-content-between  mt-2 clear-filter-btn filter-history p-0 pt-2 ">
                  <Button
                    className="text-primary text-white"
                    onClick={() => {
                      props.filterParmas(
                        { ...TrayHistoryFilterInitialState },
                        true
                      );
                      resetForm();
                    }}
                  >
                    {formatMessage('clear_all_filters')}
                  </Button>
                  <Button
                    className="ms-3"
                    variant="secondary"
                    type="submit"
                  >
                    {formatMessage('apply')}
                  </Button>
                </div>
              </Col>
            </Row>
          </FormikForm>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default TrayHistoryFilterComponent;
